import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=2c10b932&scoped=true&"
import script from "./Colors.vue?vue&type=script&lang=js&"
export * from "./Colors.vue?vue&type=script&lang=js&"
import style0 from "./Colors.vue?vue&type=style&index=0&id=2c10b932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c10b932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2c10b932', component.options)
    } else {
      api.reload('2c10b932', component.options)
    }
    module.hot.accept("./Colors.vue?vue&type=template&id=2c10b932&scoped=true&", function () {
      api.rerender('2c10b932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Styles/Colors.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Styles/Colors.vue
// module id = na37
// module chunks = 0